import { motion, useReducedMotion } from "framer-motion";

export default function SectionReveal({ children, delay = 0 }) {
  const shouldReduceMotion = useReducedMotion();

  return (
    <motion.div
      initial={{ opacity: 0, y: shouldReduceMotion ? 0 : 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{
        duration: 0.4,
        delay,
      }}
      className="w-full"
    >
      {children}
    </motion.div>
  );
}